const MAP = {
  ON_TRACK: "bg-emerald-50 text-emerald-700 border-emerald-200 dark:bg-emerald-500/15 dark:text-emerald-400 dark:border-emerald-500/30",
  AT_RISK: "bg-amber-50 text-amber-700 border-amber-200 dark:bg-amber-500/15 dark:text-amber-400 dark:border-amber-500/30",
  CRITICAL: "bg-red-50 text-red-700 border-red-200 dark:bg-red-500/15 dark:text-red-400 dark:border-red-500/30",
};
const LABEL = { ON_TRACK: "On Track", AT_RISK: "At Risk", CRITICAL: "Critical Delay" };

export function HealthBadge({ health, testId }) {
  return (
    <span
      data-testid={testId}
      className={`inline-flex items-center whitespace-nowrap rounded-md border px-2.5 py-0.5 text-[11px] font-semibold ${MAP[health] || MAP.CRITICAL}`}
    >
      {LABEL[health] || health || "—"}
    </span>
  );
}
